    // Initialize when DOM is ready
    $(document).ready(function() {
        initSwiper();
        initSwiperGallery();

        initGalleryModal();

        initLenis();
        initGSAP();
        initGSAPLayout();
        initGSAPText();
        initGSAPAnimations();

        initUspListScroll();

        initSingleProject();

        initSwitchActiveLists();
        initPartnersStack();
        initServicesAccordion();

        initSingleProjectScrollSync();

        initDynamicContentModal();

        initButtonHoverWiggle();

        initAnchorSmoothScroll();

        initMastheadScrollActive();
        initMastheadScrollDirection();

        initMobileNavigation();
    });

    /**
     * Handle page visibility changes
     */
    document.addEventListener('visibilitychange', function() {
        if (document.hidden) {
            // Pause animations when page is hidden
            if (typeof gsap !== 'undefined') {
                gsap.globalTimeline.pause();
            }
        } else {
            // Resume animations when page is visible
            if (typeof gsap !== 'undefined') {
                gsap.globalTimeline.resume();
            }
        }
    });

})(jQuery);
